import { useEffect, useState } from "react";
import { PrintByItem } from "./PrintByItem";

export const PrintByItemWrapper = ({ bundleView }) => {
  const [renderPrintByItemPage, setRenderPrintByItemPage] = useState<boolean>(true);

  useEffect(() => {
    if (!renderPrintByItemPage) {
      const timeout = setTimeout(() => {
        setRenderPrintByItemPage(true);
      }, 0);
      return () => clearTimeout(timeout);
    }
  }, [renderPrintByItemPage]);

  return (
    renderPrintByItemPage && (
      <PrintByItem bundleView={bundleView} refreshContent={() => setRenderPrintByItemPage(!renderPrintByItemPage)} />
    )
  );
};
